<template>
  <div class="contentAgreement">
    <!-- H5 版本 
    <div id="J_mobile" class="fn-hide tab animated fast">
      <div id="iotHeight"></div>
      此处添加协议内容 
      <h4>用户服务协议</h4>
      <p>
        聚牧城网站（www.jumuc.com，以下简称本站）是内蒙古聚牧城科技有限责任公司（以下简称“聚牧城”）独立开发、运营的电子商务平台。如您登录、使用本站，通过本站购买商品，须与聚牧城签订本《用户服务协议》（以下简称本协议）。
        第一条特别提醒
        1.1本协议已将可能与您的权益具有重大关系的条款用粗体字予以标注，您应重点阅读。
        1.2您有权选择同意或者不同意本协议，您点击本协议下方的“同意并继续”按钮即视为您完全接受本协议，在点击之前请您确认已知悉并完全理解本协议的全部内容。如您不同意本协议请停止使用本站。
        1.3本站所发布的各类规则、协议内容变更公告等均属于本协议不可分割的一部分，与本协议具有同等法律效力。
        1.4本协议内容及本站发布的各类规则内容可能会根据业务需要进行调整，一旦上述内容发生变动，聚牧城将会在本站以公告的方式予以公布，不再单独通知您。若您继续使用本站，即视为您已充分阅读、理解并接受修改后的协议内容；若您不同意修改后的协议内容，您有权停止使用本站。
        1.5在您意向使用聚牧城网站进行交易时，请务必确认网址为*.jumuc.com,如果在非本地址进行交易给您带来经济损失，本站概不负责。
        第二条 用户注册 2.1.用户资格
        本站的用户须为具有完全民事行为能力的自然人、法人及其他组织。若自然人不具完全民事行为能力，请不要使用本站，由此产生的一切后果由您及您的监护人承担。
        2.2用户账号 2.2.1
        具备上述用户资格的主体通过本站用户注册页面注册用户账号并设置相应的登录密码，一经注册成功，即成为本站用户。用户可以凭借用户账号及登录密码登录及使用本站。
        2.2.2您在本站注册成功后，则对本账户的一切操作行为负法律责任。请妥善管理好本人的账户和密码，如果发生遗忘或丢失，请按照本站公布的账号及密码找回规则，或者联系本站的客服人员协助找回。因账户和密码遗忘、丢失造成的一切损失，将由客户本人承担。
        2.3注册信息
        您在用户注册页面进行注册时，应提供真实、准确、完整、合法有效的注册资料，如注册资料发生变动，应及时更新资料，否则您需承担由此产生的一切责任及后果。
        第三条 使用规则
        3.1您在使用本站时，须保证遵守国家的法律法规和规章制度，遵守本协议及本站发布的规则、程序和惯例，不得利用本站从事任何非法活动。
        3.2
        您可在购买商品后，在本站特定的评论区域发表评论、意见，上传图片和其他内容，前提是其内容需真实合法。如您恶意评价商品及本站服务或上传包含软件病毒、政治宣传、商业招揽、大宗邮件或任何形式的“垃圾邮件”，由此造成的一切责任由您承担，且本站有权删除上述内容。
        第四条 交易规则 4.1商品信息
        由于您使用的登录设备的不同，观看时网页显示的差异，本站上的展示的商品图像在规格和颜色方面可能跟真实的物品不尽一致，应以商品描述及收到的商品为准。
        4.2订单
        4.2.1在您提交订单后，本站将根据您填写的订单信息，自动生成一份包含您的订单的所有必要信息的电子订单表格，您可通过确认订单页面复查订购商品的付款方式以及这些商品的运输方式和费用等信息。请您必须非常仔细地复查这些信息并纠正一切可能的错误，点击订单页面中的“确认订单”按钮意味着您认可订单表格中包含的所有信息都是正确和完整的。
        4.2.2如您需要修改订单请在确认订单页面中点击“确认订单”按钮之前进行修改，如您需要取消订单请在本站对用户订单进行审核确认之前取消。
        4.2.3您通过本站下达了订单后，本站对订单进行确认的行为仅表示系统接收到了您的订单，只有在聚牧城审核订单通过后双方之间的买卖合同才成立。本站将尽最大努力保证您所购商品与网站上公布的价格一致，但价目表和声明并不构成要约。本站有权在发现了其网站上显现的产品及订单的明显错误或缺货的情况下，单方面撤回任何承诺。同时，本站保留对产品订购的数量的限制权。
        4.2.4
        如果您在订单中填写的收货人与您本人不一致的，收货人的行为和意思表示视为您的行为和意思表示，您应对收货人的行为及意思表示的法律后果承担连带责任。
        4.2.5.关于个人订单确认
        4.2.5.1在本站下达订单后，如果您收到订单商品，并对产品价格、质量、数量均无异议，请在“我的订单”-“订单管理”中，点击“确认收货”按钮，即代表您本人已收到订单中购买商品。
        4.2.5.2在本站下达订单后，如果您未在72小时内点击“确认收货”按钮，本站将通过短信息向注册时填写的手机号码提醒您确认收货；在发出提醒信息后，如果您仍未在24小时内点击“确认收货”按钮，则本站视为您已收到订单商品，且对商品价格、质量、数量无异议。
        4.3支付款项
        4.3.1本站产品的价格和可获性都在本站上指明。这类信息将随时更改且不发任何通知。商品的价格都包含了增值税。如果发生了意外情况，在确认了您的订单后，由于供应商提价，税额变化引起的价格变化，或是由于网站的错误等造成商品价格变化，您有权取消您的订单，并希望您能及时通过电子邮件或电话通知本站客户服务部。
        4.3.2若您选择“现金支付”方式支付商品款项,您须在聚牧城审核订单通过后24小时之内支付所购商品款项，否则将视为您已取消订单。
        4.3.3若您选择“奶款支付”方式支付商品价款,
        聚牧城将有权从您的奶款中收回所售商品等额价款；
        4.3.3.1奶款系指您向第三方乳制品企业销售鲜奶后的应收账款。
        4.3.3.2若您的奶款账户中的奶款数额不足以支付商品价款，聚牧城将通过您在注册时提供的联系方式通知您支付剩余价款。您须在接到通知之日起七日内将商品价款汇入聚牧城指定银行帐户之内；逾期付款,按未付款额的千分之五向聚牧城支付违约金。
        4.4商品交付
        4.4.1由您自提的商品，自聚牧城及其他聚牧城指定的主体将商品交付承运人时起视为已交货，交付后发生的所有费用由您自行承担。
        4.4.2由聚牧城负责配送商品的，卸车费等其他费用均由您自行承担；如您在系统已经发货的情况下无故退货，您需承担因此次订单产生的所有运费及其他相关费用。
        您在收到商品后除应签收书面交付单外还应在本站上进行确认，如在5天内未在本站上进行确认或者发起退货流程，则视为您已默认收到商品。
        4.4.3商品所有权自交付时转移，因如下情况造成无法交付商品的，聚牧城不承担延迟配送的责任：
        （1）您提供的信息错误、地址不详细等原因导致的；
        （2）货物送达后无人签收，导致无法配送或延迟配送的；
        （3）情势变更因素导致的；
        （4）不可抗力因素导致的，例如：自然灾害、交通戒严、突发战争等；
        （5）用户自提货物。 4.5退货及退款
        4.5．1由于本站所售商品性质的原因，本站商品均不适用无理由退货，对此您已完全理解并接受。因商品毁损严重影响正常使用或商品质量缺陷原因退货时，您需在本站退货页面上传受损商品照片、验收报告等相关凭证，经聚牧城进行审核同意后方可退货。
        4.5.2
        在您退回商品后（在聚牧城审核同意退货后），聚牧城将在收到您退回商品之日起3日内，以您购买商品时的支付途径退还价款。
        第五条 信息及商业秘密保护
        5.1您务必妥善保管用户账号、登录密码及您在其项下填写的所有个人信息，不得将其赠与、转让、借用或者以其他的方式提供给第三方，以防您的信息及本站商业秘密的泄露。若您发现了任何非法使用用户账号或存在安全漏洞的情况，请立即通知本站并向公安机关报案。否则，您需承担由此产生的一切后果。
        5.2您在本站进行浏览、购买商品等活动时，涉及您真实姓名/名称、通信地址、联系电话、电子邮箱、购买信息等您信息及商业秘密信息的，本站将予以严格保密，除非得到您的授权或法律另有规定，本站不会向外界披露上述用户隐私信息。
        第六条 知识产权 6.1
        本站上所有内容的选材、整理、编排、排版、汇编，由本站创作的文字、图片等作品及聚牧城开发或合作开发的本站系统的著作权，无论是否明示，均为聚牧城所有。未经聚牧城允许，您不得擅自复制、修改、出版、传播、参与传播、销售、制作衍生作品等，否则，应承担由此给聚牧城造成的一切损失。
        6.2未经聚牧城授权，您不得使用聚牧城设计、使用、所有的商标，否则，应承担由此给聚牧城造成的一切损失。
        第七条 责任声明 7.1
        对于本站向您免费提供的各项网络服务引发的任何损失，聚牧城无需承担任何责任。
        7.2本站用户在本站论坛上发表的一切言论，均与本站无关，本站不负审核其言论真实性的义务。
        7.3
        由于合理的或不可避免的送货延迟对您或第三方带来的任何损失，聚牧城不负任何责任。在这种情况下，聚牧城将尽快地把任何可预知的延迟情况通知您，对此您有权选择是否取消订单。
        7.4
        对于因不可抗力或本站不能控制的原因造成的网络服务中断或其它缺陷，聚牧城不承担任何责任，但将尽力减少因此给您造成的损失和影响。
        7.5本站对任何直接、间接、偶然、特殊及继起的损害不负责任，这些损害可能来自：不正当使用网络服务，在网上购买商品或进行同类型服务，在网上进行交易，非法使用网络服务或用户传送的信息有所变动。这些行为都有可能会导致本站的形象受损，所以本站事先提出这种损害的可能性。
        八、本协议的终止
        8.1出现以下情况时，聚牧城有权单方终止本协议并注销用户账户：
        8.1.1您提供的注册信息内容不真实、不准确或存在冒用他人信息进行注册情形的；
        8.1.2您违反本协议第四条4.1的约定，涉嫌侵犯聚牧城信息及商业秘密安全的；
        8.1.3您违反本协议第五条的约定，涉嫌侵犯聚牧城所享有的知识产权的；
        8.1.4其它本站认为应当终止服务的情况。
        8.2出现以下情况时，您有权单方终止本协议：
        8.2.1本协议及本站各类规则发生变更时，您通知聚牧城不同意接受变更后的内容的；
        8.2.2本站违反本协议第四条4.2的约定，涉嫌侵犯您的信息及商业秘密安全的；
        8.2.3您有权向本站要求注销账户，经本站审核您在本站的所有买卖合同均已履行完毕，且不存在任何争议的，聚牧城将注销您的账户，且视为您已单方解除本协议。
        第九条法律适用、管辖及其他
        9.1本协议适用中华人民共和国大陆区域的法律法规。
        9.2如您与聚牧城就本协议任何条款发生争议，应协商解决，协商不成的提交呼和浩特仲裁委员会仲裁解决。
        9.3本站的客户服务电话为：400-888-3088，如您对本协议条款有任何疑问可以通过上述客户服务电话与聚牧城联系。
      </p>
      <div class="iphonex-safe-bottom"></div>
    </div>-->

    <!-- PC 版本 -->
    <div id="J_desktop" class="contentAgreement desktop agreement-group">
      <div class="title-wrap">
        <div class="title">
          <div class="tab-title-pc">
            <!-- pc的tab头部内容 -->
            <h1>用户服务协议</h1>
            <p> 聚牧城网站（www.jumuc.com，以下简称本站）是内蒙古聚牧城科技有限责任公司（以下简称“聚牧城”）独立开发、运营的电子商务平台。如您登录、使用本站，通过本站购买商品，须与聚牧城签订本《用户服务协议》（以下简称本协议）。</p>
              <p><strong>第一条特别提醒</strong></p>
              <p><strong>1.1本协议已将可能与您的权益具有重大关系的条款用粗体字予以标注，您应重点阅读。</strong></p>
              <p>1.2您有权选择同意或者不同意本协议，<strong>您点击本协议下方的“同意并继续”按钮即视为您完全接受本协议</strong>>，在点击之前请您确认已知悉并完全理解本协议的全部内容。如您不同意本协议请停止使用本站。</p>
              <p>1.3本站所发布的各类规则、协议内容变更公告等均属于本协议不可分割的一部分，与本协议具有同等法律效力。</p>
              <p><strong>1.4本协议内容及本站发布的各类规则内容可能会根据业务需要进行调整，一旦上述内容发生变动，聚牧城将会在本站以公告的方式予以公布，不再单独通知您。若您继续使用本站，即视为您已充分阅读、理解并接受修改后的协议内容；若您不同意修改后的协议内容，您有权停止使用本站。</strong></p>
              <p><strong>1.5在您意向使用聚牧城网站进行交易时，请务必确认网址为*.jumuc.com,如果在非本地址进行交易给您带来经济损失，本站概不负责。</strong></p>
              <p><strong>第二条 用户注册</strong></p>
              <p> 2.1.用户资格</p>
              <p>本站的用户须为具有完全民事行为能力的自然人、法人及其他组织。若自然人不具完全民事行为能力，请不要使用本站，由此产生的一切后果由您及您的监护人承担。</p>
              <p>2.2用户账号</p>
              <p>2.2.1具备上述用户资格的主体通过本站用户注册页面注册用户账号并设置相应的登录密码，一经注册成功，即成为本站用户。用户可以凭借用户账号及登录密码登录及使用本站。</p>
              <p>2.2.2您在本站注册成功后，则对本账户的一切操作行为负法律责任。请妥善管理好本人的账户和密码，如果发生遗忘或丢失，请按照本站公布的账号及密码找回规则，或者联系本站的客服人员协助找回。因账户和密码遗忘、丢失造成的一切损失，将由客户本人承担。</p>
              <p>2.3注册信息 </p>
               <p> 您在用户注册页面进行注册时，应提供<strong>真实、准确、完整、合法有效的注册资料</strong>，如注册资料发生变动，应及时更新资料，否则您需承担由此产生的一切责任及后果。</p>
              <p><strong>第三条 使用规则</strong>></p>
              <p>3.1您在使用本站时，须保证遵守国家的法律法规和规章制度，遵守本协议及本站发布的规则、程序和惯例，不得利用本站从事任何非法活动。</p>
              <p>3.2
              您可在购买商品后，在本站特定的评论区域发表评论、意见，上传图片和其他内容，前提是其内容需真实合法。如您恶意评价商品及本站服务或上传包含软件病毒、政治宣传、商业招揽、大宗邮件或任何形式的“垃圾邮件”，由此造成的一切责任由您承担，且本站有权删除上述内容。</p>
              <p><strong>第四条 交易规则</strong></p>
               <p>4.1商品信息</p>
              <p>由于您使用的登录设备的不同，观看时网页显示的差异，本站上的展示的商品图像在规格和颜色方面可能跟真实的物品不尽一致，应以商品描述及收到的商品为准。</p>
              <p>4.2订单</p>
              <p>4.2.1在您提交订单后，本站将根据您填写的订单信息，自动生成一份包含您的订单的所有必要信息的<strong>电子订单表格</strong>，您可通过确认订单页面复查订购商品的付款方式以及这些商品的运输方式和费用等信息。请您必须非常仔细地复查这些信息并纠正一切可能的错误，点击订单页面中的“确认订单”按钮意味着您认可订单表格中包含的所有信息都是正确和完整的。</p>
              <p> 4.2.2如您需要修改订单请在确认订单页面中点击<strong>“确认订单”</strong>按钮之前进行修改，如您需要取消订单请在本站对用户订单进行审核确认之前取消。</p>
              <p>4.2.3您通过本站下达了订单后，本站对订单进行确认的行为仅表示系统接收到了您的订单，只有在聚牧城审核订单通过后双方之间的买卖合同才成立。本站将尽最大努力保证您所购商品与网站上公布的价格一致，但价目表和声明并不构成要约。本站有权在发现了其网站上显现的产品及订单的明显错误或缺货的情况下，单方面撤回任何承诺。同时，本站保留对产品订购的数量的限制权。</p>
              <p>4.2.4如果您在订单中填写的收货人与您本人不一致的，收货人的行为和意思表示视为您的行为和意思表示，您应对收货人的行为及意思表示的法律后果承担连带责任。</p>
              <p>4.2.5.关于个人订单确认</p>
              <p>4.2.5.1在本站下达订单后，如果您收到订单商品，并对产品价格、质量、数量均无异议，请在“我的订单”-“订单管理”中，点击“确认收货”按钮，即代表您本人已收到订单中购买商品。</p>
              <p>4.2.5.2在本站下达订单后，如果您未在72小时内点击“确认收货”按钮，本站将通过短信息向注册时填写的手机号码提醒您确认收货；在发出提醒信息后，如果您仍未在24小时内点击“确认收货”按钮，则本站视为您已收到订单商品，且对商品价格、质量、数量无异议。</p>
              <p>4.3支付款项</p>
              <p>4.3.1本站产品的价格和可获性都在本站上指明。这类信息将随时更改且不发任何通知。商品的价格都包含了增值税。如果发生了意外情况，在确认了您的订单后，由于供应商提价，税额变化引起的价格变化，或是由于网站的错误等造成商品价格变化，您有权取消您的订单，并希望您能及时通过电子邮件或电话通知本站客户服务部。</p>
              <p>4.3.2若您选择“现金支付”方式支付商品款项,您须在聚牧城审核订单通过后24小时之内支付所购商品款项，否则将视为您已取消订单。</p>
              <p>4.3.3若您选择“奶款支付”方式支付商品价款,聚牧城将有权从您的奶款中收回所售商品等额价款；</p>
              <p>4.3.3.1奶款系指您向第三方乳制品企业销售鲜奶后的应收账款。</p>
              <p>4.3.3.2若您的奶款账户中的奶款数额不足以支付商品价款，聚牧城将通过您在注册时提供的联系方式通知您支付剩余价款。您须在接到通知之日起七日内将商品价款汇入聚牧城指定银行帐户之内；逾期付款,按未付款额的千分之五向聚牧城支付违约金。</p>
              <p>4.4商品交付
              <p>4.4.1由您自提的商品，自聚牧城及其他聚牧城指定的主体将商品交付承运人时起视为已交货，交付后发生的所有费用由您自行承担。</p>
              <p>4.4.2由聚牧城负责配送商品的，卸车费等其他费用均由您自行承担；如您在系统已经发货的情况下无故退货，您需承担因此次订单产生的所有运费及其他相关费用。您在收到商品后除应签收书面交付单外还应在本站上进行确认，如在5天内未在本站上进行确认或者发起退货流程，则视为您已默认收到商品。</p>
              <p>4.4.3商品所有权自交付时转移，因如下情况造成无法交付商品的，聚牧城不承担延迟配送的责任：</p>
              <p>（1）您提供的信息错误、地址不详细等原因导致的；</p>
              <p>（2）货物送达后无人签收，导致无法配送或延迟配送的；</p>
              <p>（3）情势变更因素导致的；</p>
              <p>（4）不可抗力因素导致的，例如：自然灾害、交通戒严、突发战争等；</p>
              <p><strong>（5）用户自提货物。</strong></p>
              <p> 4.5退货及退款</p>
              <p>4.5．1由于本站所售商品性质的原因，本站商品均<strong>不适用无理由退货</strong>，对此您已完全理解并接受。因商品毁损严重影响正常使用或商品质量缺陷原因退货时，您需在本站退货页面上传受损商品照片、验收报告等相关凭证，经聚牧城进行审核同意后方可退货。</p>
              <p>4.5.2在您退回商品后（在聚牧城审核同意退货后），聚牧城将在收到您退回商品之日起3日内，以您购买商品时的支付途径退还价款。</p>
              <p><strong>第五条 信息及商业秘密保护</strong></p>
              <p>5.1您务必妥善保管用户账号、登录密码及您在其项下填写的所有个人信息，不得将其赠与、转让、借用或者以其他的方式提供给第三方，以防您的信息及本站商业秘密的泄露。若您发现了任何非法使用用户账号或存在安全漏洞的情况，请立即通知本站并向公安机关报案。否则，您需承担由此产生的一切后果。</p>
              <p>5.2您在本站进行浏览、购买商品等活动时，涉及您真实姓名/名称、通信地址、联系电话、电子邮箱、购买信息等您信息及商业秘密信息的，本站将予以严格保密，除非得到您的授权或法律另有规定，本站不会向外界披露上述用户隐私信息。</p>
              <p><strong>第六条 知识产权</strong></p> 
              <p> 6.1本站上所有内容的选材、整理、编排、排版、汇编，由本站创作的文字、图片等作品及聚牧城开发或合作开发的本站系统的著作权，无论是否明示，均为聚牧城所有。未经聚牧城允许，您不得擅自复制、修改、出版、传播、参与传播、销售、制作衍生作品等，否则，应承担由此给聚牧城造成的一切损失。</p>
              <p>6.2未经聚牧城授权，您不得使用聚牧城设计、使用、所有的商标，否则，应承担由此给聚牧城造成的一切损失。</p>
              <p><strong>第七条 责任声明</strong></p>
              <p><strong>7.1对于本站向您免费提供的各项网络服务引发的任何损失，聚牧城无需承担任何责任。</strong></p>
              <p><strong>7.2本站用户在本站论坛上发表的一切言论，均与本站无关，本站不负审核其言论真实性的义务。</strong></p>
              <p><strong>7.3由于合理的或不可避免的送货延迟对您或第三方带来的任何损失，聚牧城不负任何责任。在这种情况下，聚牧城将尽快地把任何可预知的延迟情况通知您，对此您有权选择是否取消订单。</strong></p>
              <p><strong> 7.4对于因不可抗力或本站不能控制的原因造成的网络服务中断或其它缺陷，聚牧城不承担任何责任，但将尽力减少因此给您造成的损失和影响。</strong></p>
              <p><strong>7.5本站对任何直接、间接、偶然、特殊及继起的损害不负责任，这些损害可能来自：不正当使用网络服务，在网上购买商品或进行同类型服务，在网上进行交易，非法使用网络服务或用户传送的信息有所变动。这些行为都有可能会导致本站的形象受损，所以本站事先提出这种损害的可能性。</strong></p>
              <p><strong>八、本协议的终止</strong></p>
              <p>8.1出现以下情况时，聚牧城有权单方终止本协议并注销用户账户：</p>
              <p>8.1.1您提供的注册信息内容不真实、不准确或存在冒用他人信息进行注册情形的；</p>
              <p>8.1.2您违反本协议第四条4.1的约定，涉嫌侵犯聚牧城信息及商业秘密安全的；</p>
              <p>8.1.3您违反本协议第五条的约定，涉嫌侵犯聚牧城所享有的知识产权的；</p>
              <p>8.1.4其它本站认为应当终止服务的情况。</p>
              <p>8.2出现以下情况时，您有权单方终止本协议：</p>
              <p>8.2.1本协议及本站各类规则发生变更时，您通知聚牧城不同意接受变更后的内容的；</p>
              <p>8.2.2本站违反本协议第四条4.2的约定，涉嫌侵犯您的信息及商业秘密安全的；</p>
              <p>8.2.3您有权向本站要求注销账户，经本站审核您在本站的所有买卖合同均已履行完毕，且不存在任何争议的，聚牧城将注销您的账户，且视为您已单方解除本协议。</p>
              <p><strong>第九条法律适用、管辖及其他</strong></p>
              <p>9.1本协议适用中华人民共和国大陆区域的法律法规。</p>
              <p>9.2如您与聚牧城就本协议任何条款发生争议，应协商解决，协商不成的提交呼和浩特仲裁委员会仲裁解决。</p>
              <p>9.3本站的客户服务电话为：400-888-3088，如您对本协议条款有任何疑问可以通过上述客户服务电话与聚牧城联系。</p>
            
          </div>
        </div>
      </div>

      <!-- <div class="tab-contents">
         pc的tab切换内容
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "agreement",
  data() {
    return {};
  },

  // mounted() {
  //   window.fdConfig = [
  //     {
  //       title: "用户服务协议",
  //       content:
  //         '<p style="font-size:16px; text-align:center;"><strong><span style>用户服务协议</span></strong></p>',
  //       default: true,
  //     },
  //     {
  //       title: "聚牧城隐私政策",
  //       content:
  //         '<p style="font-size:16px; text-align:center;"><strong><span style="color:rgb(51, 51, 51);">聚牧城隐私政策</span></strong></p><p style="font-size:16px; text-align:right;"></strong></p>',
  //       language: "zh-Hans",
  //       default: true,
  //     }
  //   ];

  //   var isMobile = window.navigator.userAgent.indexOf("Mobile") > -1;

  //   // 注意: 这里不能使用 $, 会被后续的 Yocto 覆盖
  //   function App() {}

  //   App.prototype.init = function () {
  //     this.$page = jQuery("#J_desktop");
  //     this.initEvent();
  //     return this;
  //   };

  //   App.prototype.initEvent = function () {
  //     var $items = jQuery(".tab-title-pc>.item");
  //     $items.click(function (e) {
  //       var $this = jQuery(e.target);
  //       if ($this.hasClass("active")) {
  //         return;
  //       }

  //       var index = $this.data("index");
  //       $this.siblings().removeClass("active");
  //       $this.addClass("active");
  //       // get content
  //       var $contents = jQuery(".tab-contents>.tab-content");
  //       var $content = $contents.eq(index - 1);
  //       $contents.hide();
  //       $content.show();
  //     });
  //   };

  //   App.prototype.render = function () {
  //     this.show();
  //   };

  //   App.prototype.show = function () {
  //     this.$page.show();
  //   };

  //   if (!isMobile) {
  //     // 获取当前配置的default:true的数据
  //     var curDataAry = getDefinedData();
  //     if (curDataAry && curDataAry.length) {
  //       //  index.html之前的数据逻辑
  //       if (curDataAry.length > 3) curDataAry = curDataAry.splice(0, 3);
  //       renderHtml(curDataAry);
  //       renderContentHtml(curDataAry);
  //     }
  //     new App().init().render();
  //   }

  //   function getDefinedData() {
  //     var allAgreement = fdConfig;
  //     var curDefinedAgreement = allAgreement.filter(function (item) {
  //       return item.default === true;
  //     });
  //     return curDefinedAgreement;
  //   }

  //   //  渲染头部数据
  //   function renderHtml(data) {
  //     var htmlStr = "";
  //     data.forEach(function (item, index) {
  //       var curDataIndex = index + 1;
  //       var curTitle = item.title;
  //       var curStr =
  //         '<span data-index="' +
  //         curDataIndex +
  //         '" class="item">' +
  //         curTitle +
  //         "</span>";
  //       htmlStr += curStr;
  //     });
  //     jQuery(".tab-title-pc").prepend(htmlStr);
  //     jQuery(".tab-title-pc>.item").eq(0).addClass("active");
  //     jQuery(".tab-title-pc>.item").last().addClass("last");
  //   }

  //   //  渲染内容数据
  //   function renderContentHtml(data) {
  //     var htmlStr = "";
  //     data.forEach(function (item, index) {
  //       var curDataIndex = index + 1;
  //       var curContent = item.content;
  //       var curStr =
  //         '<div data-index="' +
  //         curDataIndex +
  //         '" class="tab-content"><div class="content-text">' +
  //         curContent +
  //         "</div></div>";
  //       htmlStr += curStr;
  //     });
  //     jQuery(".tab-contents").prepend(htmlStr);
  //     jQuery(".tab-contents>.tab-content:not(:first)").addClass("fn-hide");
  //   }
  // },

  methods: {},
};
</script>

<style lang="less" scoped>
.contentAgreement{
  width: 100%;
  #J_desktop {
    width: 90%;
    margin-left: 5%;
    h1{
      margin-top: 20px;
      margin-bottom: 20px;
    }
    p {
      margin-bottom: 10px;
      text-align: left;
      // text-indent: 30px;
    }
  }
}

</style>
